import * as React from 'react'

import Meta from '~/components/meta'
import StoresScreen from '~/screens/stores'
import { flags } from '~/utils/constants'
import getMetaInfo, { GetMetaInfoResult } from '~/utils/get-meta-info'
import redirectTo from '~/utils/redirect-to'

interface StoresPageProps {
  metaInfo: GetMetaInfoResult
}

function StoresPage(props: StoresPageProps) {
  const { metaInfo } = props

  return (
    <>
      <Meta {...metaInfo} title="Tiendas" />
      <StoresScreen />
    </>
  )
}

StoresPage.getInitialProps = (context: PageContext): StoresPageProps | void => {
  if (!context.hasFlag(flags.LIST_STORES)) {
    return redirectTo('/', context)
  }

  return { metaInfo: getMetaInfo(context) }
}

export default StoresPage
